import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-terms-activation',
  imports: [NzIconModule, TranslateModule],
  templateUrl: './terms-activation.component.html',
  styleUrl: './terms-activation.component.scss',
})
export class TermsActivationComponent {
  constructor(private router: Router) {}

  protected back(): void {
    this.router.navigate(['/activation']);
  }
}
